<template>
    <div class="famous-pedia-create">
        <!-- 1. 顶部菜单栏 -->
        <div class="famous-pedia-create-content width90p">
            <famous-create-title-bar></famous-create-title-bar>
        </div>

        <!-- 2. 主要表单部分 -->
        <!-- 2.1 四柱 -->
        <advanced-collate-form
            v-if="curPediaCreateTabIndex == 0"
            v-bind:itemSize="itemSize"
            v-bind:basicPos="basicPos"
            v-bind:chooseGroupFunc="clickChooseGroup"
            v-bind:chooseLabelFunc="clickChooseLabel">
        </advanced-collate-form>
        <!-- 2.2 选择八字 -->

        <!-- 2.3 输入时间 -->
        <div class="width90p" v-if="curPediaCreateTabIndex == 2">
            <collate-form 
                v-bind:parentNode="parentNode" 
                v-bind:chooseGroupFunc="clickChooseGroup"
                v-bind:chooseLabelFunc="clickChooseLabel">
            </collate-form>
        </div>

        <!-- 3. 创建按钮部分 -->
        <div v-if="curPediaCreateTabIndex != 1" class="famous-pedia-bottom-bar dsp-flex">
            <div class="famous-pedia-btn-back" @click.passive="clickBack">返回</div>
            <div class="famous-pedia-btn-start" @click.passive="clickStart">起盘并创建此八字百科</div>
        </div>

        <!-- 5. 选择地址组件 -->
        <van-overlay v-show="showArea" @click.passive="clickShowAreaOverlay" />
        <vant-area v-show="showArea"></vant-area>

        <!-- 6. 输入生日日期组件 -->
        <van-popup v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <input-birthday-panel></input-birthday-panel>
        </van-popup>

        <!-- 7. 重复八字过滤弹框 -->
        <van-popup v-bind:value="showSamePop" class="layout-same-select-pop-box" @click-overlay="clickSameSelectOverlay">
            <vant-same-select-pop
                v-bind:popTitle="'已存在四柱相的八字，请选择从已有八字创建还是以新八字创建：'"
                v-bind:noteText="'选择已有：'"
                v-bind:buttonText="'以新八字创建'"
                v-bind:selectedList="recordSameEightWordList"
                v-bind:itemFunc="clickSameListItem"
                v-bind:saveFunc="clickSameSave">
            </vant-same-select-pop>
        </van-popup>

        <router-view></router-view>
    </div>
</template>

<script>
import FamousCreateTitleBar from '../../layouts/famouspedia/FamousCreateTitleBar.vue'
import AdvancedCollateForm from '../../layouts/collate/AdvancedCollateForm.vue'
import CollateForm from '../../layouts/collate/CollateForm.vue'
import VantArea from '../../layouts/vant/VantArea.vue'
import InputBirthdayPanel from '../../components/InputBirthdayPanel.vue'
import VantSameSelectPop from '../../layouts/vant/VantSameSelectPop.vue'
import { MOMENT_TIME } from '../../modules/momenttime'
import { CONFIG } from '../../modules/config'
import { SCHEME } from '../../modules/utils'
export default {
    name: 'FamousPediaCreate',
    components: { FamousCreateTitleBar, AdvancedCollateForm, CollateForm, VantArea, InputBirthdayPanel, VantSameSelectPop },
    computed: {
        showSamePop() {
            return this.$store.state.record.showSamePop;
        },
        recordSameEightWordList() {
            return this.$store.state.record.recordSameEightWordList;
        },
        curPediaCreateTabIndex() {
            return this.$store.state.famouspedia.curPediaCreateTabIndex;
        },
        showArea() {
            return this.$store.state.collate.showArea;
        },
        showBirthday() {
            return this.$store.state.collate.showBirthday;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            parentNode: {'name': 'FamousPedia'},
            itemSize: {width: 0, height: 0},
            basicPos: {x: 0, y: 0}  //第一个item的值，用来计算点击item的pos值，以确定三角形的定位
        }
    },
    mounted() {
        var me = this;
        var siZhuEightWordArr = this.$store.state.collate.advanced.siZhuEightWordArr;
        if(siZhuEightWordArr.length == 0){
            this.$router.replace('/famouspedia');
            return;
        }
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
            
            var topDiv = document.getElementsByClassName('famous-pedia-create-content')[0];
            var mainDiv = document.getElementsByClassName('advanced-collate-main')[0];
            var formDiv = document.getElementsByClassName('advanced-collate-form')[0];
            var itemBoxDiv = document.getElementsByClassName('layout-asb-item')[0];
            var itemDiv = document.getElementsByClassName('layout-asb-box')[0];
            if(!itemBoxDiv || !itemDiv) { return; }
            var x = parseInt(itemBoxDiv.clientWidth / 2) - 15,
                y = topDiv.clientHeight + formDiv.clientHeight + itemDiv.clientHeight*2 + 45;
            this.$set(this.basicPos, 'x', x);
            this.$set(this.basicPos, 'y', y);
            this.$set(this.itemSize, 'width', itemBoxDiv.clientWidth);
            this.$set(this.itemSize, 'height', (itemDiv.clientHeight + 20));
            console.log('initDom----', this.basicPos.x, this.basicPos.y, this.itemSize)
        },
        clickShowAreaOverlay() {
            this.$store.state.collate.showArea = false;
        },
        clickShowBirthdayOverlay() {
            this.$store.state.collate.showBirthday = false;
            this.$bus.emit('resetIPBPKeyBoard');
        },
        clickChooseGroup() {
            var curPath = this.$router.history.current.fullPath;
            if(curPath.indexOf('embedded') != -1) {
                curPath = curPath.replace('/famouspediacreate', '/famouspediacreate/choosegroup');
                this.$router.replace(curPath);
            } else {
                this.$router.replace('/famouspediacreate/choosegroup');
            }
        },
        clickChooseLabel() {
            var curPath = this.$router.history.current.fullPath;
            if(curPath.indexOf('embedded') != -1) {
                curPath = curPath.replace('/famouspediacreate', '/famouspediacreate/label');
                this.$router.replace(curPath);
            } else {
                this.$router.replace('/famouspediacreate/label');
            }
        },
        clickSameSelectOverlay() {
            this.$store.state.record.showSamePop = false;
        },
        clickSameListItem(data) {
            this.$store.state.record.showSamePop = false;
            var me = this,
                personInfo = this.$store.state.record.recordOriginalData[data.id];
            console.log('clickSameListItem--------', data, personInfo)
            if(personInfo) {
                this.$store.dispatch('famouspedia/addBaike', {
                    data: personInfo,
                    cb: function() {
                        me.goToEditPage();
                    }
                });
            }
        },
        clickSameSave() {
            var me = this,
                formData = this.getDefaultFormData();
            console.log('clickSameSave', formData);
            if(formData) {
                this.$store.state.record.showSamePop = false;
                this.$store.dispatch('famouspedia/addBaziBaike', {
                    formData: formData,
                    cb: function() {
                        me.goToEditPage();
                    }
                });
            }
        },
        clickBack() {
            var curPath = this.$router.history.current.fullPath;
            if(curPath.indexOf('embedded') != -1) {
                SCHEME.closeWebView();
            }else {
                this.$router.replace('/famouspedia');
            }
            this.$store.dispatch('allrecord/resetRecordData');
            // 重置tab为四柱
            this.$store.state.famouspedia.curPediaCreateTabIndex = 0;
        },
        clickStart() { 
            // 共用组件获取的表单数据
            var me = this,
                formData = this.getDefaultFormData();
            console.log('clickStart------', formData);
            if(formData) {
                this.$store.dispatch('record/checkRecordListSameSiZhu', {
                    formData: formData,
                    cb: function() {
                        me.$store.dispatch('famouspedia/addBaziBaike', {
                            formData: formData,
                            cb: function() {
                                me.goToEditPage();
                            }
                        });
                    }
                });
            }
        },
        goToEditPage() {
            this.$toast('创建百科草稿成功，可在[我的百科]中查看');
            var me = this;
            var curPath = this.$router.history.current.fullPath;
            setTimeout(() => {
                if(curPath.indexOf('embedded') != -1) {
                    curPath = curPath.replace('/famouspediacreate', '/famouspediaedit')
                    me.$router.replace(curPath);
                }else {
                    me.$router.replace('/famouspediaedit');
                }
            }, 100);
        },
        getDefaultFormData() {
            var formData = Object.assign({}, this.$store.state.collate.formData);
            // 处理生日时间:返回之后时间没有默认设置了,设置一个默认值；
            var starttime = formData.birthday == '' && this.curPediaCreateTabIndex == 0 ? MOMENT_TIME.getTimeStampByNow() : formData.birthday;
            if(starttime == '') {
                this.$toast('请填写生日');
                return null;
            }else {
                formData.birthday = typeof(starttime) == 'number' ? MOMENT_TIME.getFormateTimeByTimeStamp(starttime * 1000) : starttime;
            }
            // 处理姓名:可以空名起盘，生成命名取为"未命名"
            formData.f_name = formData.f_name == '' ? '未命名' : formData.f_name;
            // 处理分组:
            formData.f_group = this.$store.state.group.choosedGroup.id;
            formData.f_group = !formData.f_group || formData.f_group == '' ? 0 : formData.f_group;
            // 处理性别:
            formData.sex = formData.sex == '' ? 0 : formData.sex;
            // 处理location:
            formData.location = this.curPediaCreateTabIndex == 0 ? '' : formData.location;
            // 处理早晚子时:
            formData.zwzs = parseInt(this.settingConfigData.zaoWanZiShi);
            // 处理标签及备注信息
            formData.label = this.$store.state.label.selectedLabelId;
            formData.remark = this.$store.state.label.remarkStringData;
            return formData;
        },
    }
}
</script>